// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
  max-width: 100%;
}
.payroll-review {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}
.payroll-frequency-field {
  margin-bottom: 0.75rem;
}
.payroll-frequency-label {
  display: block;
  margin-bottom: 0.25rem;
  font-size: 0.8rem;
  font-weight: 600;
  color: #495057;
}
`, "",{"version":3,"sources":["webpack://./src/app/screening-module/income-wizard/phases/stream-phase/stream-types/stream-review-payroll.component.less"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,WAAA;EACA,eAAA;AACF;AAEA;EACE,WAAA;EACA,eAAA;EACA,sBAAA;AAAF;AAGA;EACE,sBAAA;AADF;AAIA;EACE,cAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAFF","sourcesContent":[":host {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n}\n\n.payroll-review {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.payroll-frequency-field {\n  margin-bottom: 0.75rem;\n}\n\n.payroll-frequency-label {\n  display: block;\n  margin-bottom: 0.25rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #495057;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
